import { Component, HostBinding } from '@angular/core';

@Component({
  selector: 'l-crud-container',
  standalone: true,
  templateUrl: './crud-container.component.html',
})
export class CrudContainerComponent {

  @HostBinding('class')
  public classes = 'flex-1 flex flex-col border-radius p-5 overflow-hidden foreground';

}
